import axios from 'axios';
import { API_BASE_URL, handleApiError } from './_apiBase';
import { BillingCategory, PriceList, Specification, SmsOverview } from '../types/billing';

// ── Fakturaunderlag (huvudadmin) ─────────────────────────────────────────────

export const fetchPriceList = async (): Promise<PriceList> => {
    try { return (await axios.get<PriceList>(`${API_BASE_URL}/superuser/billing/prices`)).data; }
    catch (e) { return handleApiError(e, 'Hämta prislistan'); }
};

export const savePrice = async (input: { category: BillingCategory; tenantId: string; tierMin: number; monthlyPrice: number }): Promise<void> => {
    try { await axios.put(`${API_BASE_URL}/superuser/billing/prices`, input); }
    catch (e) { return handleApiError(e, 'Spara pris'); }
};

export const deletePriceRow = async (id: number): Promise<void> => {
    try { await axios.delete(`${API_BASE_URL}/superuser/billing/prices/${id}`); }
    catch (e) { return handleApiError(e, 'Ta bort pris'); }
};

export const fetchSmsOverview = async (month: string): Promise<SmsOverview> => {
    try { return (await axios.get<SmsOverview>(`${API_BASE_URL}/superuser/billing/sms`, { params: { month } })).data; }
    catch (e) { return handleApiError(e, 'Hämta sms per kund'); }
};

export const fetchSpecification = async (tenantId: string, month: string): Promise<Specification> => {
    try { return (await axios.get<Specification>(`${API_BASE_URL}/superuser/billing/specification`, { params: { tenantId, month } })).data; }
    catch (e) { return handleApiError(e, 'Hämta underlaget'); }
};
